const EXCLUDE_SYMBOL = Symbol();

/** A combination of Array.map() and Array.filter() */
export function mapAndExclude<T, U>(
  array: readonly T[],
  /** The function to execute on each element in the array. Return the exclude symbol to exclude the value from the result. */
  callback: (
    /** A symbol that should be returned to exclude the value */
    exclude: typeof EXCLUDE_SYMBOL,
    /** A value in the array */
    value: T,
    /** The index of the value in the array */
    index: number,
    /** The array that the value belongs to */
    array: readonly T[],
  ) => U | typeof EXCLUDE_SYMBOL,
) {
  const result: U[] = [];
  for (const [index, value] of array.entries()) {
    const mappedValue = callback(EXCLUDE_SYMBOL, value, index, array);
    if (mappedValue !== EXCLUDE_SYMBOL) {
      result.push(mappedValue);
    }
  }
  return result;
}

/** Joins an array of values with the specified separators */
export function joinWithGrammar(
  /** The array of values to join */
  array: unknown[],
  /** The separator to use between values (default: ", ") */
  separator = ", ",
  /** The separator to use before the last value (default: " og ") */
  finalSeparator = " og ",
) {
  let result = "";
  const lastIndex = array.length - 1;
  for (const [index, value] of array.entries()) {
    if (index) result += index === lastIndex ? finalSeparator : separator;
    result += String(value);
  }
  return result;
}

/** Converts an array of key-value pairs to a record/object */
export function entriesToRecord<K extends PropertyKey, V>(
  /** The entries to convert to a record */
  entries: [K, V][],
) {
  return Object.fromEntries(entries) as Record<K, V>;
}
